export const BtnText = {
  'ConnectWallet': 'Connect Wallet',
  'InstallMetamask': 'Install Metamask',
}